import { ConstValues, createEnum } from '@cloud-wave/neon-common-lib';

export const TaskAction = createEnum('CREATE', 'UPDATE', 'DELETE');
export type TTaskAction = ConstValues<typeof TaskAction>;
